import { tv, type VariantProps } from 'tailwind-variants'

export const skeletonVariants = tv({
  base: 'bg-surface-white-200 animate-pulse',
  variants: {
    variant: {
      rectangle: 'rounded-[666px]',
      square: 'rounded-sm',
      circle: 'rounded-full'
    }
  },
  defaultVariants: {
    variant: 'rectangle'
  }
})

export type TSkeletonProps = VariantProps<typeof skeletonVariants> & {
  className?: string
  width?: string
  height?: string
  style?: React.CSSProperties
}

/**
 * @deprecated Use `Skeleton` from `@alternative/acqua/atoms` instead. The acqua-ui Skeleton is being phased out in favor of the acqua design system.
 */
export const Skeleton = ({
  variant,
  className,
  width = 'w-full',
  height = 'h-[18px]',
  style
}: TSkeletonProps): JSX.Element => (
  <div
    className={skeletonVariants({
      variant,
      className: `${width} ${height} ${className ?? ''}`
    })}
    style={style}
    data-testid='skeleton'
  />
)
